import React, {useState} from "react";
import { CloudPlatformProps } from "../../../../../components/cloud-platform/types";
import {RefButton} from "../../../../../components/like-button-ref/like-button-ref";
import {Translate} from "../../../../../locales/locales-utils";
import {ContactUsForm} from "../../../../../components/forms/contact-us/contact-us-form";
import {ContactUsExtendedForm} from '../../../../../components/forms/contact-us-extended/contact-us-extended-form';

export const cloudPlatformEventsProps = (): CloudPlatformProps => {
    const [modalIsOpen, setIsOpenModal] = useState(false);

    function modalOpenHandle(e: Event) {
        e.preventDefault();
        setIsOpenModal(true);
    }

    function modalCloseHandle() {
        setIsOpenModal(false);
    }

    return {
        title: Translate("Index.BookServices.Title"),
        subtitle: Translate("Index.BookServices.SubTitle"),
        cards: [
            {
                title: Translate("Index.BookServices.ItemsTitle"),
                body: (
                    <div>
                        {Translate("Index.BookServices.Items")}
                        <RefButton
                            type="button"
                            target="_blank"
                            text={Translate("Index.BookServices.Button")}
                            variant="primary"
                            size="sm"
                            classNames="order-button"
                            onClick={modalOpenHandle}
                        />
                        <ContactUsExtendedForm isOpen={modalIsOpen} closeHandle={modalCloseHandle} />
                    </div>
                ),
                video: (
                    <iframe width="600" height="330" src="https://rutube.ru/play/embed/0cec1e922ff6658bd02d634291c1f06c/" title="RuTube video player" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="lazy"></iframe>
                ),
                position: "right",
                classes: ["cloud-platform-events-card"]
            }
        ],
        animationDisabled: true
    }
};
